import { AxiosResponse } from "axios";
import BaseAPI from "../api";


const path: string = "contact";

export type contactType = {
    contact_name: string;
    contact_address: string;
    contact_tel: string;
    contact_suggestions: string;
    latitude: string;
    longitude: string;
}

export class ContactApi extends BaseAPI {
    static create(body: contactType): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static findOne(): Promise<AxiosResponse> {
        return this.api.get(`${path}`)
    }
    static update(id_contact: number, body: contactType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_contact}`, body)
    }
}